import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found-view',
  standalone: true,
  imports: [],
  templateUrl: './not-found-view.component.html',
  styleUrl: './not-found-view.component.scss'
})
export class NotFoundViewComponent {

}
